<script lang="ts">
    import Warning from "../../public/icons/Warning.svelte";
import Background from "./Background.svelte";

    export let error: object; 
    const errorMessage = error.toString().replaceAll("Error: ", "");

</script>


<div data-iframe-height class="error-screen"> 
    <Background />
    <div class="weatherIcon">
    <Warning fill={"var(--error-color)"} />
    </div>
    <div class="error-header label">
        Unable to display widget
    </div>
    <div class="error-message label">
        {errorMessage}
    </div>

</div>



<style>
.error-screen {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    aspect-ratio: 16/9;
    overflow: hidden;
    position: relative;
    font-size: 24px;
    padding: 5%;
}

.error-header {
    color: var(--primary-color);
}
.error-message {
    color: var(--secondary-color);
    text-align: center;
}

</style>